module.exports = {
	"articleTitle1": "On and Off the Mat: Practicing Mindfulness at aUM Yoga Studio ...",
	"catImage": "orangestar.png",
	"totalCats": 1,
	"name": "aUM Yoga",
	"articleLink2": "https://www.michigandaily.com/section/arts/boaa-best-yoga-studio",
	"articleSnippet1": "Mar 22, 2017 ... A rapidly growing number of students can be spotted toting yoga mats around \ncampus en route to one of the many studios that subsist in Ann ...",
	"articleSnippet2": "Best Yoga Studio: aUM Yoga . Emilie Farrugia/DAILY. Tess Garcia. Senior Arts \nEditor. Sunday, April 2, 2017 - 8:34pm ...",
	"totalMisc": 1,
	"articleTitle2": "Best Yoga Studio: aUM Yoga ",
	"address": "1220 S University Ave #215, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170412/amc.NEW_.aUMyoga.9.8.15.002.jpg?itok=G5WruB7y",
			"author": "Emilie Farrugia",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.274935,
		"lng": -83.733612
	},
	"tips": [],
	"articleLink1": "https://www.michigandaily.com/section/arts/and-mat-practicing-mindfulness-aum-yoga-studio",
	"categories": {
		"yogaspot": 1,
		"bestofaa": 1,
		"location": 1,
		"recarea": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/aum.json
// module id = 816
// module chunks = 0